import { render } from "./cdrBatchServer.vue?vue&type=template&id=2b2329be&scoped=true"
import script from "./cdrBatchServer.vue?vue&type=script&lang=js"
export * from "./cdrBatchServer.vue?vue&type=script&lang=js"

import "./cdrBatchServer.vue?vue&type=style&index=0&id=2b2329be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b2329be"

export default script